// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__281j9","empty":"ModalGraph_empty__QIvv5"};